import SelectInteractionBase, { SelectFeatureEventType, SelectFeatureEvent } from '@/components/maps/interactions/SelectInteraction';

class SelectInteraction extends SelectInteractionBase {

	fireDeselectedFeature(evt, feature) {
		// [TODO] Qual a razão deste IF???
		// if(evt.type != SelectFeatureEventType.SELECT){
		this.dispatchEvent(
			new SelectFeatureEvent(
				SelectFeatureEventType.DESELECT_FEATURE,
				evt.selected,
				[feature],
				evt.mapBrowserEvent,
				feature
			)
		);
		// }
	}
};

export default SelectInteraction;